import Parseable from '@/misc/Parseable';
import MagazineApiEntity from '@/interfaces/MagazineApiEntity.interface';

/**
 * Defines a magazines object
 */

export default class Magazine extends Parseable {

    public id!: string;
    public publicationId!: string;
    public name!: string;
    public categoryIds: string[] = [];
    // TODO is not implemented yet, comes with https://28apps.atlassian.net/browse/SWR-53
    public language!: string;
    public publicationDate!: string;
    public publisherId!: string;
    public coverUrl!: string;
    public pageCount!: number;
    public advertisement!: boolean;
    public showSinglePage!: boolean; // TODO: Use correct attribute from the API !!! This is just for testing purposes

    public static parseFromObject(object: MagazineApiEntity): Magazine {

        const magazine = new Magazine();
        magazine.id = object.id_magazine;
        magazine.publicationId = object.id_magazine_publication;
        magazine.name = object.name;
        if (object.ids_magazine_category) {
            magazine.categoryIds = object.ids_magazine_category.split(',');
        }
        magazine.language = object.magazine_language;
        magazine.publicationDate = object.date_of_publication;
        magazine.publisherId = object.id_publisher;
        magazine.coverUrl = `https://${object.cover_url}`;
        magazine.pageCount = Number(object.page_max);
        magazine.advertisement = object.advertisement;
        magazine.showSinglePage = object.single_page_only;
        return magazine;
    }

    public parseToObject(): Partial<Magazine> {
        return { ...this };
    }
}
